import { WsNavBrowseRow, WS_NAV_NESTED_PAD } from '@/components/layout/left-sidebar.components'
import { testIds } from '@/lib/test-ids'

export type KnowledgeHubWorkspaceNavRowProps = {
  workspaceId: string
  padLeft: number
  active: boolean
  expanded: boolean
  onToggleExpand: () => void
  onOpenQueue: () => void
  icon: React.ReactNode
  label: string
  reviewRequestedCount: number
  needsReviewCount: number
  onOpenReviewQueue: () => void
  onOpenNeedsReview: () => void
  activeFilter?: 'review-requested' | 'needs-review' | null
}

/** Browse-nested Knowledge Hub row with review-queue and needs-review sub-rows. */
export function KnowledgeHubWorkspaceNavRow({
  workspaceId,
  padLeft,
  active,
  expanded,
  onToggleExpand,
  onOpenQueue,
  icon,
  label,
  reviewRequestedCount,
  needsReviewCount,
  onOpenReviewQueue,
  onOpenNeedsReview,
  activeFilter,
}: KnowledgeHubWorkspaceNavRowProps) {
  return (
    <div className="min-w-0">
      <WsNavBrowseRow
        role="button"
        padLeft={padLeft}
        active={active}
        chevron={{
          expanded,
          onClick: onToggleExpand,
        }}
        icon={icon}
        label={label}
        onClick={onOpenQueue}
        data-testid={testIds.leftSidebar.workspaceKnowledgeHubRow(workspaceId)}
      />
      {expanded ? (
        <div className="ws-nav-inline-group min-w-0 max-w-full">
          <WsNavBrowseRow
            role="button"
            padLeft={WS_NAV_NESTED_PAD}
            active={activeFilter === 'review-requested'}
            icon={null}
            label={
              <span className="truncate">
                Review queue ({reviewRequestedCount})
              </span>
            }
            onClick={onOpenReviewQueue}
            data-testid={testIds.leftSidebar.workspaceKnowledgeHubReviewQueue(workspaceId)}
          />
          <WsNavBrowseRow
            role="button"
            padLeft={WS_NAV_NESTED_PAD}
            active={activeFilter === 'needs-review'}
            icon={null}
            label={
              <span className="truncate">
                Needs review ({needsReviewCount})
              </span>
            }
            onClick={onOpenNeedsReview}
            data-testid={testIds.leftSidebar.workspaceKnowledgeHubNeedsReview(workspaceId)}
          />
        </div>
      ) : null}
    </div>
  )
}
